import firebase from 'firebase/app';
import 'firebase/functions';

const config = {
  apiKey: 'AIzaSyDWEeTFL5IR1CG8W4L1fB4S5KP6IsaKH04',
  authDomain: 'portfolio-app-a3014.firebaseapp.com',
  databaseURL: 'https://portfolio-app-a3014.firebaseio.com',
  projectId: 'portfolio-app-a3014',
  storageBucket: 'portfolio-app-a3014.appspot.com',
  messagingSenderId: '1053658865165',
  appId: '1:1053658865165:web:ebb3b9b1265c539c25bf44',
  measurementId: 'G-J2SVX5H25G',
};

firebase.initializeApp(config);

export const functions = firebase.functions();

export default firebase;
